export const initialValues = {
    montoLibreDisposicion: "",
    montoRentaTemporal: "",
    radioButton: ""
};